import V1 from '@/system-modules/console/v1/ConsoleV1'
import { ISysConsoleModule } from '@/contracts/system-modules/console/ISysConsoleModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

class ConsoleProvider extends Provider<ISysConsoleModule> {
  realizations: Record<string, ISysConsoleModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysConsoleModule | null } = { module: null }

export function SysConsoleProviderModule(): ISysConsoleModule {
  const version = SystemModuleConfig.getConsoleVersion()

  if(!instance.module){
    instance.module = new ConsoleProvider().module(version)
  }

  return instance.module
}
